import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Picks one phrase from each ordered bucket (start/middle/end) so the
 * AI "thinking" indicator stays narratively coherent — first phrase always
 * comes from the early-stage bucket, last from the closing bucket — while
 * each call returns a different combination from the underlying pool.
 */
export function samplePhases(...buckets: string[][]): string[] {
  return buckets.map((bucket) => bucket[Math.floor(Math.random() * bucket.length)]);
}

/**
 * Returns the [start, middle, end] phrase buckets for the chat thinking
 * indicator. Memoised on the `t` reference so callers can pass straight to
 * `samplePhases` or `ChatMessages`.
 */
export function useChatThinkingPhaseBuckets(): string[][] {
  const { t } = useTranslation();
  return useMemo(
    () => [
      [t('thinkingPhases.chat.start1'), t('thinkingPhases.chat.start2')],
      [
        t('thinkingPhases.chat.middle1'),
        t('thinkingPhases.chat.middle2'),
        t('thinkingPhases.chat.middle3')
      ],
      [t('thinkingPhases.chat.end1'), t('thinkingPhases.chat.end2')]
    ],
    [t]
  );
}
